import React, { ReactElement } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { FormNodeTermsAgreementModel, SettingTermKeysValues } from '../../../../../shared/kiosk';
import { SettingTermKeys } from '../../../../../shared/settings';
import { AbstractElementEditor, UpdateFormProps } from './AbstractElementEditor';

export class TermsAgreementEditor extends AbstractElementEditor<FormNodeTermsAgreementModel> {
  public getDescription(): string {
    return 'Terms agreement';
  }

  public getName(): string {
    return 'Terms agreement';
  }

  public getIcon(): string {
    return 'text_snippet';
  }

  public override getDefaultValues(): Partial<Omit<FormNodeTermsAgreementModel, 'id' | 'type'>> {
    return {
      markdown: 'I have read and agree to the policies above.',
      termsKey: 'privacy',
    };
  }

  public override getUpdateForm({
    node,
    update,
    ts,
  }: UpdateFormProps<FormNodeTermsAgreementModel>): ReactElement {
    return (
      <>
        <FormGroup>
          <Label for="termsKey">{ts('input_type')}</Label>
          <Input
            onChange={(e) => {
              update({ ...node, termsKey: e.target.value as SettingTermKeys });
            }}
            type="select"
            value={node.termsKey}
          >
            {SettingTermKeysValues.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="markdown">{ts('text_to_be_displayed_by_the_checkbox')}:</Label>
          <Input
            onChange={(e) => {
              update({ ...node, markdown: e.target.value });
            }}
            rows={15}
            type="textarea"
            value={node.markdown}
          />
        </FormGroup>
      </>
    );
  }
}
